import {useReducedMotion, motion} from 'framer-motion';
import Summary from './Summary/Summary';
import dateToString from '../../utilities/dateToString';
import languageSensitiveNum from '../../utilities/languageSensitiveNum';
import {invoiceInfoVariants} from '../../utilities/framerVariants';
import styles from './InvoiceInfo.module.scss'

const InvoiceInfo = ({invoice}) => {
    const shouldReduceMotion = useReducedMotion();
    const variant = (element) => {
        return shouldReduceMotion
            ? invoiceInfoVariants.reduced
            : invoiceInfoVariants[element];
    };

    return (
        <motion.article
            className={styles.invoiceInfo}
            variants={variant('info')}
            initial="hidden"
            animate="visible"
            exit="exit"
        >
            <div className={styles.container}>
                <div className={styles.key}>
                    <h3>
                        <span className={styles.hashtag}># </span>
                        {invoice.number}
                    </h3>
                </div>

                <address className={styles.sender}>
                    <h4>Sender</h4>
                    <span>{`${invoice.sender.name} ${invoice.sender.surname}`}</span>
                    <span>Tax Number: {invoice.sender.taxNumber}</span>
                    <span>Address: {invoice.sender.address.street}, {invoice.sender.address.city}, {invoice.sender.address.postCode}, {invoice.sender.address.country}</span>
                </address>

                <div className={styles.createdDate}>
                    <h4>Invoice Date</h4>
                    <p>{dateToString(invoice.createdAt)}</p>
                </div>

                <div className={styles.clientInfo}>
                    <h4>Bill to</h4>
                    <p>{`${invoice.customer.name} ${invoice.customer.surname}`}</p>
                    <address className={styles.clientAddress}>
                        <span>Address: {invoice.customer.address.region}, {invoice.customer.address.city}, {invoice.customer.address.district}, {invoice.customer.address.street}, {invoice.customer.address.zip}</span>
                    </address>
                </div>

                <div className={styles.email}>
                    <h4>Sent to</h4>
                    <p>{invoice.customer.email}</p>
                    <p>{invoice.sender.email}</p>
                </div>

                <div className={styles.payment}>
                    <h4>Payment Due</h4>
                    <p>{invoice.dueDate}</p>
                </div>

                <div className={styles.billingInfo}>
                    <h4>Billing Information</h4>
                    <div className={styles.billingRow}>
                        <strong>Beneficiary Bank:</strong>
                        <p>{invoice.billingInfo.beneficiaryBank}</p>
                    </div>
                    <div className={styles.billingRow}>
                        <strong>IBAN:</strong>
                        <p className={styles.longText}>{invoice.billingInfo.iban}</p>
                    </div>
                    <div className={styles.billingRow}>
                        <strong>SWIFT/SEPA/BIC Code:</strong>
                        <p className={styles.longText}>{invoice.billingInfo.bicCode}</p>
                    </div>
                    <div className={styles.billingRow}>
                        <strong>Bank Address:</strong>
                        <p>{invoice.billingInfo.bankAddress}</p>
                    </div>
                </div>

            </div>
            <Summary invoice={invoice}/>
            <div className={styles.total}>
                <h4>Amount Due</h4>
                <h1>$ {languageSensitiveNum(invoice.total)}</h1>
            </div>
        </motion.article>
    );
};

export default InvoiceInfo;
